import type { TFunction } from "i18next";

import { API_URLS } from "shared/constants";
import type { EntitySoccerRoles } from "shared/types";
import { BackendEntityType, EntitySoccerClubRoles } from "shared/types";

export const getFollowEPURL = (entityType: BackendEntityType | EntitySoccerRoles) => {
	switch (entityType) {
		case BackendEntityType.SoccerClub:
			return API_URLS.CLUB.FOLLOW;
		case BackendEntityType.SoccerCompetition:
			return API_URLS.COMPETITION.FOLLOW;
		case BackendEntityType.SoccerTeam:
			return API_URLS.TEAM.FOLLOW;
		case BackendEntityType.SoccerLeague:
			return API_URLS.LEAGUE.FOLLOW;
		case BackendEntityType.SoccerGroup:
			return API_URLS.GROUP.FOLLOW;
		case BackendEntityType.CorePerson:
		case EntitySoccerClubRoles.PLAYER:
			return API_URLS.PLAYER.FOLLOW;
	}

	return "";
};

export const getUnfollowEPURL = (entityType: BackendEntityType | EntitySoccerRoles) => {
	switch (entityType) {
		case BackendEntityType.SoccerClub:
			return API_URLS.CLUB.UNFOLLOW;
		case BackendEntityType.SoccerCompetition:
			return API_URLS.COMPETITION.UNFOLLOW;
		case BackendEntityType.SoccerTeam:
			return API_URLS.TEAM.UNFOLLOW;
		case BackendEntityType.SoccerLeague:
			return API_URLS.LEAGUE.UNFOLLOW;
		case BackendEntityType.SoccerGroup:
			return API_URLS.GROUP.UNFOLLOW;
		case BackendEntityType.CorePerson:
		case EntitySoccerClubRoles.PLAYER:
			return API_URLS.PLAYER.UNFOLLOW;
	}

	return "";
};

export const getInviteFollowEPURL = (entityType: BackendEntityType | EntitySoccerRoles) => {
	switch (entityType) {
		case BackendEntityType.SoccerClub:
			return API_URLS.INVITATION.INVITE_CLUB_FOLLOWERS;
		case BackendEntityType.SoccerCompetition:
			return API_URLS.INVITATION.INVITE_COMPETITION_FOLLOWERS;
		case BackendEntityType.SoccerTeam:
			return API_URLS.INVITATION.INVITE_TEAM_FOLLOWERS;
		case BackendEntityType.SoccerLeague:
			return API_URLS.INVITATION.INVITE_LEAGUE_FOLLOWERS;
		case BackendEntityType.SoccerGroup:
			return API_URLS.INVITATION.INVITE_GROUP_FOLLOWERS;
		case BackendEntityType.CorePerson:
		case EntitySoccerClubRoles.PLAYER:
			return API_URLS.INVITATION.INVITE_USER_FOLLOWERS;
	}

	return "";
};

export const getFollowParamName = (entityType: BackendEntityType | EntitySoccerRoles) => {
	switch (entityType) {
		case BackendEntityType.SoccerClub:
			return "clubId";
		case BackendEntityType.SoccerCompetition:
			return "competitionId";
		case BackendEntityType.SoccerTeam:
			return "teamId";
		case BackendEntityType.SoccerLeague:
			return "leagueId";
		case BackendEntityType.SoccerGroup:
			return "groupId";
		case BackendEntityType.CorePerson:
		case EntitySoccerClubRoles.PLAYER:
			return "playerId";
	}
	return "";
};

export const renderFollowedText = (entityType: BackendEntityType | EntitySoccerRoles, t: TFunction) => {
	if (!entityType || !t) return "";

	switch (entityType) {
		case BackendEntityType.SoccerClub:
			return t("invitation:club_followed");
		case BackendEntityType.SoccerCompetition:
			return t("invitation:competition_followed");
		case BackendEntityType.SoccerTeam:
			return t("invitation:team_followed");
		case BackendEntityType.SoccerLeague:
			return t("invitation:league_followed");
		case BackendEntityType.SoccerGroup:
			return t("invitation:group_followed");
		case BackendEntityType.CorePerson:
			return t("invitation:user_followed");
		case EntitySoccerClubRoles.PLAYER:
			return t("invitation:player_followed");
	}

	return "";
};

export const renderUnFollowedText = (entityType: BackendEntityType | EntitySoccerRoles, t: TFunction) => {
	if (!entityType || !t) return "";

	switch (entityType) {
		case BackendEntityType.SoccerClub:
			return t("invitation:club_unfollowed");
		case BackendEntityType.SoccerCompetition:
			return t("invitation:competition_unfollowed");
		case BackendEntityType.SoccerTeam:
			return t("invitation:team_unfollowed");
		case BackendEntityType.SoccerLeague:
			return t("invitation:league_unfollowed");
		case BackendEntityType.SoccerGroup:
			return t("invitation:group_unfollowed");
		case BackendEntityType.CorePerson:
			return t("invitation:user_unfollowed");
		case EntitySoccerClubRoles.PLAYER:
			return t("invitation:player_unfollowed");
	}

	return "";
};
